import styled from 'styled-components';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';

interface Props {
  isOver: boolean;
  isError: boolean;
}

export const Container = styled(Box)<Props>(({ theme, isOver, isError }) => {
  return {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px dashed ${
      isError
        ? theme.colors.error[700]
        : isOver
        ? theme.colors.neutral[500]
        : theme.colors.neutral[300]
    }`,
    borderRadius: `${theme.radii.medium}px`,
    background: isOver ? theme.colors.neutral[100] : theme.colors.white,
  };
});
